import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignOut = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 3.25C3 2.2835 3.7835 1.5 4.75 1.5H10.25C10.6642 1.5 11 1.83579 11 2.25C11 2.66421 10.6642 3 10.25 3H4.75C4.61193 3 4.5 3.11193 4.5 3.25V20.75C4.5 20.8881 4.61193 21 4.75 21H10.25C10.6642 21 11 21.3358 11 21.75C11 22.1642 10.6642 22.5 10.25 22.5H4.75C3.7835 22.5 3 21.7165 3 20.75V3.25Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.0064 12.75L15.7055 16.2342C15.4207 16.5349 15.4335 17.0096 15.7342 17.2945C16.0349 17.5793 16.5096 17.5665 16.7945 17.2658L21.2945 12.5158C21.5685 12.2265 21.5685 11.7735 21.2945 11.4842L16.7945 6.73419C16.5096 6.43349 16.0349 6.42066 15.7342 6.70554C15.4335 6.99041 15.4207 7.46511 15.7055 7.76581L19.0063 11.25H10.75C10.3358 11.25 10 11.5858 10 12C10 12.4142 10.3358 12.75 10.75 12.75H19.0064Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgSignOut;
